'use client';

import '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';
import { slugify } from '../Utils/helpers.js';
import { RECENT_SEARCH, defaultSearchFilterParams } from './constants.js';
import { SEARCH_PARAMS } from './types.js';

var getDistrictIdFromLocations = function (locations) {
    var updatedList = [];
    // Loop through cities
    locations === null || locations === void 0 ? void 0 : locations.map(function (location) {
        var _a;
        // Loop through district
        (_a = location === null || location === void 0 ? void 0 : location.childrenIds) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            // Do not push -1 to list
            if (item === -1) {
                return;
            }
            if (updatedList.indexOf(item) >= 0) {
                return;
            }
            updatedList.push(item);
        });
    });
    return updatedList;
};
var buildSearchUrl = function (keyword, locationObj, language) {
    var params = {};
    if (keyword) {
        params[SEARCH_PARAMS.QUERY] = keyword.replace(/ /g, '-');
    }
    if (Array.isArray(locationObj) && locationObj.length > 0) {
        params[SEARCH_PARAMS.LOCATION] = locationObj.map(function (i) { return i.parentId; }).join('.');
        var districtId = getDistrictIdFromLocations(locationObj);
        if (districtId && districtId.length > 0) {
            params[SEARCH_PARAMS.DISTRICT] = districtId.join('.');
        }
    }
    if (Object.keys(params).length > 0) {
        var paramsString = '?' + new URLSearchParams(params).toString();
        var baseUrl = language === ELanguage.VI ? '/viec-lam' : '/jobs';
        return baseUrl + paramsString;
    }
    else {
        return language === ELanguage.VI ? '/tim-viec-lam/tim-tat-ca-viec-lam' : '/job-search/all-jobs';
    }
};
var buildJobsByCompanyUrl = function (companyId, companyName, lang) {
    var prefix = lang === 'en' ? 'companies' : 'nha-tuyen-dung';
    return "/".concat(prefix, "/").concat(slugify(companyName), "-c").concat(companyId);
};
var changeLocation = function (url, isReturn, onlyFillInput) {
    if (isReturn === void 0) { isReturn = false; }
    var locationHref = window.location.origin;
    if (onlyFillInput) {
        return '';
    }
    // Remove wowcv from location (Because wowcv is using different domain)
    if (locationHref.indexOf('wowcv.') >= 0) {
        locationHref = locationHref.replace('wowcv.', '');
        // only for staging
        if (locationHref.indexOf('staging-vietnamworks') >= 0) {
            locationHref = locationHref.replace('staging-vietnamworks', 'staging.vietnamworks');
        }
        // only for release
        if (locationHref.indexOf('release-vietnamworks') >= 0) {
            locationHref = locationHref.replace('release-vietnamworks', 'release.vietnamworks');
        }
        if (!isReturn) {
            window.location.assign(locationHref + url);
        }
        return locationHref + url;
    }
    else {
        if (!isReturn) {
            window.location.assign(url);
        }
        return url;
    }
};
var getLocalStorage = function (mainKey, key) {
    if (mainKey === void 0) { mainKey = 'params'; }
    var params = typeof window !== 'undefined' ? localStorage.getItem(mainKey) : '';
    var defaultValue = {};
    if (mainKey === RECENT_SEARCH) {
        defaultValue = [];
    }
    else if (mainKey === 'params') {
        if (key === 'query') {
            defaultValue = '';
        }
        else if (key === 'categoryId') {
            defaultValue = [];
        }
        else if (key === 'companyIndustries') {
            defaultValue = [];
        }
        else if (key === 'locationId') {
            defaultValue = [];
        }
        else if (key === 'locations') {
            defaultValue = [];
        }
        else if (key === '') {
            defaultValue = defaultSearchFilterParams;
        }
    }
    var localParams = params !== '' && params !== null ? JSON.parse(params) : defaultValue;
    if (localParams[key] !== undefined && localParams[key] !== null && key !== '') {
        return localParams[key];
    }
    else if (key !== undefined && key !== '' && localParams[key] === undefined) {
        return defaultValue;
    }
    return localParams;
};

export { buildJobsByCompanyUrl, buildSearchUrl, changeLocation, getDistrictIdFromLocations, getLocalStorage };
//# sourceMappingURL=searchbarHelpers.js.map
